import { VariantEndpoints } from '@/modules/inventory/variant/api/variantEndpoints'

/**
 * Variant endpoint instance
 * instantiate Variant api class with different api path
 */
export const variantEndpoints = new VariantEndpoints('variant')
export const variantOptionsEndpoints = new VariantEndpoints('variant_option')
